import { render } from "./PointsCell.vue?vue&type=template&id=6a3ed7e6"
import script from "./PointsCell.vue?vue&type=script&lang=js"
export * from "./PointsCell.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__